import { jsx } from "react/jsx-runtime";
import Head from "next/head";
const StructuredData = ({
  data
}) => /* @__PURE__ */ jsx(Head, { children: /* @__PURE__ */ jsx(
  "script",
  {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(data)
    }
  }
) });
export {
  StructuredData as default
};
